import styled from 'styled-components';

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const Line = styled.hr`
  width: 50%;
  flex: 1;
  margin: 0;
  border-top: 1px solid #cfd8dc;
  border-left: none;
`;

export const ChildrenPadding = styled.span`
  padding: 0 16px;
`;
